import React from 'react';
import SectionTitle from '../../yourProperties/Title';
import useTranslate from '../../../../customHooks/useTranslate';
import Card from '../../../../muiComponents/Card';

const MainInformation = props => {
    const { notes } = props;
    const title = useTranslate('notes');

    return (
        <section className='booking__section'>
            <SectionTitle text={title} />
            <Card className='padding20'>{notes}</Card>
        </section>
    );
};

export default MainInformation;
